<span
  class="material-symbols-outlined ui-icon"
  [style.font-size.px]="size()"
  [style.font-variation-settings]="fontVariationSettings()"
  [style.color]="color() || 'inherit'"
  [attr.title]="title()"
  aria-hidden="true"
  >{{ name() }}</span
>
